/**
 * IntersectionObserver-driven reveal animations.
 *
 * Adds `is-visible` class when an element enters the viewport, then unobserves.
 * Falls back to instant-visible for unsupported browsers.
 */
export function initObserve() {
  const targets = document.querySelectorAll('.observe');
  if (!targets.length) return;

  if (!('IntersectionObserver' in window)) {
    targets.forEach((el) => el.classList.add('is-visible'));
    return;
  }

  const io = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          io.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.12, rootMargin: '0px 0px -8% 0px' }
  );

  targets.forEach((el) => io.observe(el));
}
